import { ISMT_ChuDe_DeThiIn } from "../../../../model/respone/de-thi/ISMT_ChuDe_DeThiIn";
import { generateActionTypeIds } from "../../generateActionTypeIds";
import IGenericActionType from "../../IGenericActionType";

export const eChuDeThiInActionsObj = {
  LOAD_START: 0,
  LOAD_SUCCESS: {} as ISMT_ChuDe_DeThiIn[],
  LOAD_ERRR: "",

  SAVE_START: {} as ISMT_ChuDe_DeThiIn,
  SAVE_SUCCESS: {} as ISMT_ChuDe_DeThiIn,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_ChuDe_DeThiIn,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_VIEW_DOICAUHOI_MODAL: {} as ISMT_ChuDe_DeThiIn,
  CLOSE_VIEW_DOICAUHOI_MODAL: undefined,

  CHANGE_REQUEST: {} as any,

  SHOW_PROGRESS_MODAL: {} as number[],
  CLOSE_PROGRESS_MODAL: undefined,

  DELETE_MULTIPLE_START: {} as number[],
  DELETE_MULTIPLE_SUCCESS: undefined,
  DELETE_MULTIPLE_ERROR: "",
};
export const eChuDeThiInActionIds = generateActionTypeIds(
  eChuDeThiInActionsObj,
  "CHU_DE_THI_IN"
);
export type IChuDeThiInActionTypes = IGenericActionType<
  typeof eChuDeThiInActionsObj,
  "CHU_DE_THI_IN"
>;
